import React, { Component } from 'react';
import './Calling.less';
import Draggable from "react-draggable";
import { callBuyer, callSeller, endBuyerCall, endSellerCall } from 'services/Manager';
import { SocketContext } from '../../context/socket';
import callStatus from '../../constants/callStatus';
import calleeType from '../../constants/calleeType';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const noticationTimeout = 5000;

const initialState = {
    
    initials: '',
    startCall: false,
    confCallID: '', 
    calleeCallID: '',
    callStatus: '',
    callTime: ''
}

class Calling extends Component {
    static contextType = SocketContext;
    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        const socket = this.context;
        this.onLoad(socket);
    }

    onLoad = async (socket) => {
        console.log(this.props.sbr, this.props.currentUser, this.props.callInfo);
        let res = {};
        
        this.extractInitials();
        this.setState({ callStatus: callStatus.INITIATED, startCall: true });
        //this.startSocketListener(socket, 'test'/*this.state.sellerCallID*/);
        if(this.props.callInfo.calleeType == calleeType.BUYER){
            res = await callBuyer(this.props.sbr.singleBuyerRequestID, this.props.callInfo.buyerID);
        }
        else if(this.props.callInfo.calleeType == calleeType.SELLER){
            res = await callSeller(this.props.sbr.singleBuyerRequestID, this.props.callInfo.sellerID, this.props.callInfo.phone);
        }

        if(res.resStatus == 200){
            console.log(res.data);
            
            let calleeCallID = 0;
            if(this.props.callInfo.calleeType == calleeType.BUYER){
                calleeCallID = res.data.buyerCallID;
            }
            else if(this.props.callInfo.calleeType == calleeType.SELLER){
                calleeCallID = res.data.sellerCallID;
            }
            this.setState({startCall: true, confCallID: res.data.confCallID, calleeCallID: calleeCallID}, () => {
               this.startSocketListener(socket, calleeCallID);
            })
        }
        else{
            this.setState({startCall: false, confCallID: '', sellerCallID: ''});
            if(this.props.endCall){
                this.props.endCall();
            }

            NotificationManager.error(res.message, '', noticationTimeout);
        }
    }

    componentDidUpdate(prevProps){
        if(this.props != prevProps){
            this.extractInitials();
        }
        //console.log(this.props.sbr, this.props.currentUser, this.props.callInfo);
        
    }

    extractInitials(){
        const nameArray = this.props.callInfo.name.split(' ');
        let initials = '';

        if(nameArray.length > 0){
            initials += nameArray[0].substring(0,1);
        }
        if(nameArray.length > 1){
            initials += nameArray[1].substring(0,1);
        }

        this.setState({initials: initials});
    }

    endCall = async () => {
        this.setState({callStatus: callStatus.ENDING});
        let res = {};
        if(this.props.callInfo.calleeType == calleeType.BUYER){
            res = await endBuyerCall(this.props.callInfo.buyerID, this.state.confCallID);
        }
        else if(this.props.callInfo.calleeType == calleeType.SELLER){
            res = await endSellerCall(this.props.callInfo.sellerID, this.state.confCallID);
        }

        this.setState({startCall: false, confCallID: '', sellerCallID: ''}, () => {
            if(this.props.endCall){
                this.props.endCall();
            }
        })
    }

    startSocketListener = (socket, calleeCallID) => {
        console.log("calleeCallID : " + calleeCallID);
        socket.on(calleeCallID, (message) => {
            console.log(message);
            this.setState({callStatus: message.status});
            if(message.status == callStatus.IN_PROGRESS){
                let seconds = 0;
                let secondsToShow = 0;
                this.callTimer = setInterval(() => {
                    seconds++;
                    secondsToShow++;
                    if(secondsToShow == 60){
                        secondsToShow = 0;
                    }
                    const minutes = Math.floor(seconds/60);
                    const time = `${minutes.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}:${secondsToShow.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`
                    this.setState({callTime: time});
                }, 1000)
                
                
            }
            if(message.status == callStatus.COMPLETED || message.status == callStatus.FAILED || message.status == callStatus.CANCELED || message.status == callStatus.NO_ANSWER){
                clearInterval(this.callTimer);
                this.setState({startCall: false, confCallID: '', calleeCallID: ''});
                if(this.props.endCall){
                    this.props.endCall();
                }
            }
        });
    }
    render() {
        return ( this.state.startCall &&
            <Draggable 
            handle=".calling-container">
                <div className='calling-container'>
                    <div className='sub-container'>
                    <div className='header'>
                        <div className='manager'>
                                <div className='icon'>
                                    <svg id="Team_Icon" data-name="Team Icon" xmlns="http://www.w3.org/2000/svg" width="21.173" height="17.322" viewBox="0 0 21.173 17.322">
                                        <defs>
                                            <clipPath id="clip-path">
                                                <rect id="Rectangle_8955" data-name="Rectangle 8955" width="21.173" height="17.322" fill="#ffe9b9" />
                                            </clipPath>
                                        </defs>
                                        <g id="Group_16225" data-name="Group 16225" clip-path="url(#clip-path)">
                                            <path id="Path_29445" data-name="Path 29445" d="M81.583,149.627c.288.262.567.533.864.784a2.281,2.281,0,0,0,3.145.026,5.408,5.408,0,0,0,.707-.7.278.278,0,0,1,.387-.086,7.2,7.2,0,0,1,2.915,2.218,7.038,7.038,0,0,1,1.506,4.578,4.712,4.712,0,0,1-.116.916,2.531,2.531,0,0,1-2.123,1.987,13.323,13.323,0,0,1-2.981.238q-2.231.012-4.462-.013a9.161,9.161,0,0,1-2.532-.3,2.462,2.462,0,0,1-1.865-2.167,7.02,7.02,0,0,1,4.457-7.486c.044-.017.092-.027.138-.04l-.041.05" transform="translate(-73.199 -142.267)" fill="#ffe9b9" />
                                            <path id="Path_29446" data-name="Path 29446" d="M160.827,2.994a2.977,2.977,0,0,1,5.919-.478,4.025,4.025,0,0,1-.158,1.779,6.543,6.543,0,0,1-1.737,3.1,1.406,1.406,0,0,1-2.124-.009A6.219,6.219,0,0,1,161.188,4.8a5.5,5.5,0,0,1-.361-1.806" transform="translate(-152.967 0)" fill="#ffe9b9" />
                                            <path id="Path_29447" data-name="Path 29447" d="M2.379,112.033a2.638,2.638,0,0,0,.232.281,1.532,1.532,0,0,0,2.3.017c.284-.259.285-.261.625-.078A4.076,4.076,0,0,1,6.9,113.527a7.324,7.324,0,0,0-2.334,1.991c-.354.471-.636,1-.956,1.493-.043.068-.116.171-.171.168-.785-.033-1.577-.03-2.352-.14-.677-.1-.956-.476-1.052-1.16a3.714,3.714,0,0,1,2.348-3.846" transform="translate(-0.001 -106.558)" fill="#ffe9b9" />
                                            <path id="Path_29448" data-name="Path 29448" d="M295.756,114.032a3.161,3.161,0,0,1,1.546-1.213c.047-.019.137.044.2.084a5.06,5.06,0,0,0,.839.56,1.474,1.474,0,0,0,1.561-.405,3.3,3.3,0,0,0,.268-.284,3.645,3.645,0,0,1,2.263,2.866,3.694,3.694,0,0,1,.011,1.087c-.089.647-.529,1-1.308,1.08-.492.051-.988.065-1.483.079a.318.318,0,0,1-.249-.124,8.36,8.36,0,0,0-3.645-3.728" transform="translate(-281.302 -107.262)" fill="#ffe9b9" />
                                            <path id="Path_29449" data-name="Path 29449" d="M47.43,29.95a1.439,1.439,0,0,1,1.483-1.535,1.409,1.409,0,0,1,1.4,1.513,3.659,3.659,0,0,1-.782,2.01l-.016.019c-.452.528-.873.525-1.3-.024a3.769,3.769,0,0,1-.789-1.982" transform="translate(-45.112 -27.026)" fill="#ffe9b9" />
                                            <path id="Path_29450" data-name="Path 29450" d="M328.706,28.4a1.419,1.419,0,0,1,1.426,1.563,3.721,3.721,0,0,1-.777,1.938q-.673.866-1.338,0a3.682,3.682,0,0,1-.761-1.917,1.463,1.463,0,0,1,1.449-1.579" transform="translate(-311.258 -27.014)" fill="#ffe9b9" />
                                        </g>
                                    </svg>


                                </div>
                            <div className='name'>
                                {`${this.props.currentUser.firstName} ${!_.isEmpty(this.props.currentUser.lastName) ? this.props.currentUser.lastName.substring(0, 1) : ''}`}
                            </div>
                        </div>
                        {(this.state.callStatus == callStatus.IN_PROGRESS || this.state.callStatus == callStatus.RINGING /*|| this.state.callStatus == callStatus.INITIATED*/)  &&
                        <div className='dc-icon' onClick={this.endCall}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25.289" height="25.289" viewBox="0 0 25.289 25.289">
                                <path id="Call_Drop_Icon" data-name="Call Drop Icon" d="M12.482,16.842a11.246,11.246,0,0,1-5.4-1.712A14.562,14.562,0,0,1,.475,6.985,8.1,8.1,0,0,1,.094,3.11,3.871,3.871,0,0,1,2.436.159a1.367,1.367,0,0,1,1.572.2A10.18,10.18,0,0,1,6.538,3.749a1.05,1.05,0,0,1-.123,1.183c-.35.423-.718.833-1.108,1.22A1.227,1.227,0,0,0,5.022,7.94a10.49,10.49,0,0,0,3.966,3.928A1.22,1.22,0,0,0,10.7,11.6c.41-.4.833-.783,1.274-1.146a1.073,1.073,0,0,1,1.214-.105,10.681,10.681,0,0,1,3.282,2.406,1.46,1.46,0,0,1,.226,1.8A4.2,4.2,0,0,1,12.482,16.842Z" transform="translate(24.577 12.615) rotate(135)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1" />
                            </svg>

                        </div>
                        }
                    </div>
                    <div className='body' >
                        <div className='inprogress-icon'>
                            {/*<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.25" y1="0.224" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stop-color="#80e5f4" />
                                        <stop offset="1" stop-color="#5a8bf0" />
                                    </linearGradient>
                                </defs>
                                <circle id="Caller_Name_Icon" data-name="Caller Name Icon" cx="22.5" cy="22.5" r="22.5" fill="url(#linear-gradient)" />
        </svg>*/}
                            {this.state.initials}

                        </div>
                        <div className='seller-name-timer'>
                            <div className='seller-name'>
                                {this.props.callInfo.name}
                            
                            </div>
                            {
                                (this.state.callStatus == callStatus.INITIATED || this.state.callStatus == callStatus.RINGING || this.state.callStatus == callStatus.ENDING) && 
                                <div className='call-timer animation'>
                                {_.startCase(this.state.callStatus)}
                                </div>
                            }
                            {this.state.callStatus == callStatus.IN_PROGRESS && 
                            <div className='call-timer'>
                                {this.state.callTime}
                            </div>
                            }
                        </div>
                    </div>
                    </div>
                </div>
            </Draggable>
        )
    }
}

export default Calling